import ConsoleApi from "apps/console/enums/consoleApi";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { ApiConsoleUser } from "../user/list/types";
import { ApiConsoleUserSetPassword } from "shared/types/ApiConsoleUserSetPassword";

export function useGetConsoleUserProfile({ consoleUserId }: { consoleUserId?: string }) {
  return useGetApiData<ApiConsoleUser>(
    ConsoleApi.GET_CONSOLE_USER_PROFILE,
    { pathParams: { consoleUserId } },
    { enabled: Boolean(consoleUserId) }
  );
}

export function useUpdateConsoleUserProfile() {
  const copies = useCopies();
  return usePostApiData<ApiConsoleUser, ApiConsoleUser>(ConsoleApi.UPDATE_CONSOLE_USER_PROFILE, {
    onSuccess: () => successToast(copies.get("console.user.profile.update.success.msg"))
  });
}

export function useChangePassword() {
  const copies = useCopies();
  return usePostApiData<boolean, ApiConsoleUserSetPassword>(ConsoleApi.CHANGE_PASSWORD, {
    clientOptions: { trimAndRemoveNull: false },
    onSuccess: () => successToast(copies.get("password.changed.successfully"))
  });
}
